export interface CardImageProps {
  image: string
  content: string
}

export function CardImage({ image, content }: CardImageProps) {
  return (
    <div className="flex h-auto w-full items-center justify-center rounded-lg bg-white md:min-h-52 md:py-0 lg:mb-0">
      <img
        className="aspect-square h-full w-2/5 rounded-l-lg object-cover object-center md:flex 2xl:w-1/3"
        src={image}
        alt={image}
      />
      <p className="flex-1 p-5 text-center text-lg text-monochromatic-500 lg:text-start xl:text-xl">
        {content}
      </p>
    </div>
  )
}
